import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchReservationTrackingMethodOptions } from '../../sagas/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchReservationTrackingMethodOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FAILURE]: (state, { payload: error }) =>
    set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchReservationTrackingMethodOptionsHandler(
    fetchReservationTrackingMethodOptions
  )
});
